import crediten from "./crediten";
import dashboarden from "./Dashboarden";
import docen from "./docen";
import helpen from "./helpen";
import invoiceen from "./invoiceen";
import offeren from "./offeren";
import ordersen from "./ordersen";
import producten from "./producten";
import supporten from "./supporten";
import promotionen from "./promotionen";
import reviewen from "./reviewen";
import deliveryen from "./deliveryen";
import issuesen from "./issuesen";
import reportsen from "./reportsen";
import invreporten from "./invreporten";
import receipten from "./receipten";
import notificationen from "./notificationen";
import assigndeliveryen from "./assigndeliveryen";
import driveren from "./driveren";
import suppliertracken from "./suppliertracken";
import dashboardhomeen from "./dashboardhomeen";
import popupen from "./popupen";
import bulken from "./bulken";
import profileen from "./profileen";
import categoryen from "./categoryen";
import productdetailsen from "./productdetailsen";
// import all other files same way

export default {
  ...crediten,
  ...dashboarden,
  ...docen,
  ...helpen,
  ...invoiceen,
  ...offeren,
  ...ordersen,
  ...producten,
  ...supporten,
  ...promotionen,
  ...reviewen,
  ...deliveryen,
  ...issuesen,
  ...reportsen,
  ...invreporten,
  ...receipten,
  ...notificationen,
  ...assigndeliveryen,
  ...driveren,
  ...suppliertracken,
  ...dashboardhomeen,
  ...popupen,
  ...bulken,
  ...profileen,
  ...categoryen,
  ...productdetailsen,
  // ...add all remaining files
};